'use strict';

var React = require('react');

var SvgConfettiMajor = function SvgConfettiMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.029 3.033a.75.75 0 0 1 .5.935l-.703 2.313a.75.75 0 0 1-1.436-.436l.703-2.313a.75.75 0 0 1 .936-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.75a.75.75 0 0 0-1.5 0v.25h-.25a.75.75 0 0 0 0 1.5h.25v.25a.75.75 0 0 0 1.5 0v-.25h.25a.75.75 0 0 0 0-1.5h-.25v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.306 7.746a1.75 1.75 0 0 0-2.834.521l-2.093 4.669a2.75 2.75 0 0 0 .565 3.07l.051.05a2.75 2.75 0 0 0 3.07.565l4.668-2.093a1.75 1.75 0 0 0 .521-2.834l-3.948-3.948Zm-1.465 1.135a.25.25 0 0 1 .405-.074l3.948 3.947a.25.25 0 0 1-.075.405l-4.668 2.093a1.25 1.25 0 0 1-1.395-.257l-.051-.05a1.25 1.25 0 0 1-.257-1.396l2.093-4.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3a.75.75 0 0 1 .75.75v.25h.25a.75.75 0 1 1 0 1.5h-.25v.25a.75.75 0 0 1-1.5 0v-.25h-.25a.75.75 0 0 1 0-1.5h.25v-.25a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.25a.75.75 0 0 0-1.5 0v.25h-.25a.75.75 0 0 0 0 1.5h.25v.25a.75.75 0 0 0 1.5 0v-.25h.25a.75.75 0 0 0 0-1.5h-.25v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.53 7.53a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.578 11.032a.75.75 0 1 0-.413-1.442l-2.343.672a.75.75 0 1 0 .413 1.442l2.343-.672Z"
  }));
};
SvgConfettiMajor.displayName = "ConfettiMajor";

exports.SvgConfettiMajor = SvgConfettiMajor;
